import { Box } from '@mui/material';
import { Text } from 'mbd-components/text';
export function EndpointTag(props){
  const nameMap = {
    'casts/feed/trending': 'trending',
    'casts/feed/for-you': 'for you',
    'casts/feed/popular': 'popular'
  }
  const colorMap = {
    'casts/feed/trending': '#475569',
    'casts/feed/for-you': '#7b68e3',
    'casts/feed/popular': '#7F83AA' 
  }
  return (
    <Box px={1} py={0.5} sx={{backgroundColor: colorMap[props.endpoint], borderRadius: 1}}>
      <Text variant='small' color='white'>{nameMap[props.endpoint]}</Text>
    </Box>
  )
}
